/**
 * Errors a request rejects with after the app has already moved the user on: to
 * /login when the session expired, or to not-found when the record isn't theirs.
 * The caller has nothing left to show, so these are not worth reporting.
 */
export const SESSION_EXPIRED_ERROR = 'SessionExpiredError';
export const RECORD_NOT_FOUND_ERROR = 'RecordNotFoundError';

/** Rejected with when the auth check took over the request, instead of resolving with no body. */
export function sessionExpiredError() {
  return { name: SESSION_EXPIRED_ERROR, message: 'The request was not authorized; the app has moved on.' };
}

export function isRedirectedRequestError(error: any) {
  return error?.name === SESSION_EXPIRED_ERROR || error?.name === RECORD_NOT_FOUND_ERROR;
}

/** Editors start their loads without awaiting them, so these would surface as unhandled rejections. */
export function ignoreUnhandledRedirectedRequestErrors(target: Window = window) {
  target.addEventListener('unhandledrejection', (event) => {
    if (isRedirectedRequestError(event.reason)) event.preventDefault();
  });
}
